import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { Animated } from "react-animated-css";
import { Container, Jumbotron } from "reactstrap";
import "../../App.css";

class Portfolio extends Component {
  render() {
    return (
      <Container>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Jumbotron>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./17.jpg)",
                  paddingBottom: "95%",
                }}
              />
              <div class="cd-c">
                <div class="cd-t">Single Slices of New York Cheesecase</div>
                <div class="cd-st t--upper t--subtitle">$10</div>
              </div>
            </div>

            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./16.jpg)",
                  paddingBottom: "95%",
                }}
              />
              <div class="cd-c">
                <div class="cd-t">Single Slices Banana Cheesecake</div>
                <div class="cd-st t--upper t--subtitle">$10</div>
              </div>
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./22.jpg)",
                  paddingBottom: "95%",
                }}
              />
              <div class="cd-c">
                <div class="cd-t">Single Speciality Cupcakes</div>
                <div class="cd-st t--upper t--subtitle">$3.50</div>
              </div>
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./photos/IMG_6093.jpg)",
                  paddingBottom: "95%",
                }}
              />
              <div class="cd-c">
                <div class="cd-t">Single Frosted Cupcakes</div>
                <div class="cd-st t--upper t--subtitle">$2.50</div>
              </div>
            </div>
            <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
              <div
                className="cd-ic"
                style={{
                  backgroundImage: "url(./macron.jpg)",
                  paddingBottom: "95%",
                }}
              />
              <div class="cd-c">
                <div class="cd-t">Single Macrons</div>
                <div class="cd-st t--upper t--subtitle">$1.50</div>
              </div>
            </div>
          </Jumbotron>
        </Animated>
      </Container>
    );
  }
}

export default Portfolio;
